import { useEffect, useState } from "react";

import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";

import Grid from "@mui/material/Grid";

import Button from "@mui/material/Button";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import { getObjectFromGoogleJwt } from "../../services/UserService";

import { loadGapiInsideDOM } from "gapi-script";
import { loadAuth2, loadAuth2WithProps, loadClientAuth2 } from "gapi-script";

// for time picker
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("America/New_York");

const ManageMeetings2 = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_googleJwt] = useLocalStorage("Auth", "gjwt", null);

  useEffect(() => {}, []);

  const handleClickCreate = async () => {
    const CLIENT_ID =
      "55954634468-jp58t37klj69rr0l1vljnsmmg6d0pltm.apps.googleusercontent.com";
    const SCOPES = "https://www.googleapis.com/auth/calendar";
    const API_KEY = "Xp7QvYjpEw1YluNhCVIIlmJc";

    const googleUserObj = getObjectFromGoogleJwt(_googleJwt);
    // await loadGapiInsideDOM();
    // console.log(googleUserObj);
    console.log("GAPI:");
    console.log(window.gapi);

    window.gapi.load("client:auth2", () => {
      window.gapi.client
        .init({
          // Your API Key
          apiKey: API_KEY,
          // Your OAuth 2.0 client ID
          clientId: CLIENT_ID,
          scope: "https://www.googleapis.com/auth/calendar", // Example
        })
        .then(() => {
          console.log("here");
          // You now have access to gapi and its client objects
          // You can perform further actions here like signing in users
          console.log(window.gapi.auth2);
          // doCalendar();
          const authInstance = window.gapi.auth2.getAuthInstance();

          authInstance.signIn().then((googleUser) => {
            const authResponse = googleUser.getAuthResponse();
            const accessToken = authResponse.access_token;
            console.log("Access Token:", accessToken);
            // Use the access token to make authenticated API calls
            doCalendar(accessToken);
          });
        });
    });
  };

  const doCalendar = (accessToken) => {
    const TEST_EVENT = {
      summary: "Example Event",
      location: "New York, NY",
      description: "a description for this",
      start: {
        dateTime: "2025-07-16T10:00:00-04:00",
        timeZone: "America/New_York",
      },
      end: {
        dateTime: "2025-07-16T11:00:00-04:00",
        timeZone: "America/New_York",
      },
    };

    fetch("https://www.googleapis.com/calendar/v3/calendars/primary/events", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(TEST_EVENT),
    })
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        console.log(data);
        alert("event created check google calendar");
      });
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Manage My Meetings" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Grid container spacing={2}>
          <Grid item sx={6}>
            <Button
              variant="contained"
              onClick={handleClickCreate}
              title="Create Meeting"
            >
              Create
            </Button>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ManageMeetings2;
